exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.sort-icons {\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  width: 20px;\r\n  padding-top: 1px;\r\n  padding-right: 4px;\n}\n.sort-icons > .v-icon {\r\n  display: block !important;\n}\r\n", ""]);

// exports
